<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import Reporter from "../../lib/error.js";
    import Util from "../../lib/util.js";

    import { allProjects } from "../../Participaid.svelte";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Overlay from "../Overlay.svelte";
    import LoadingModal from "../LoadingModal.svelte";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let projects = [];
    export let selected = "";
    //export let value = "";
    export let label = "";
    export let help = "";
    export let allowIndeterminate = true;
    export let style;
    export let variant = "outlined";
    export let fullwidth = true;

    let loadRequest;
    let errorResult;

    // TODO: move to util
    function log(msg) {
        console.log(`[ProjectDropdown] ${msg}`);
    }

    if (!projects.length) {
        log(`loading projects...`);

        loadRequest = allProjects()
            .then(res => {
                log(`received list of projects`);
                log(res);

                projects = res.data.projects;
            })
            .catch(res => {
                errorResult = Reporter.error(`[ProjectDropdown] there was an error loading projects`, res);
            })
    }

    $: if (selected) {
        console.log(`Project dropdown selection changed: ${selected}`);

        // TODO: this is a hack.
        // see: https://gitlab.com/eyevestor/Evalueaid/app/-/issues/21
        if (Util.isGuid(selected)) {
            dispatch("selection", selected);
        }
        else {
            projects.forEach(proj => {
                if (proj.title == selected) {
                    dispatch("selection", proj.id);
                }
            })
        }
    }

    $: {
        log(`projects[] changed in ProjectsDropdown`);
        log(projects);

        if (!allowIndeterminate && !selected && projects.length) {
            log(`selecting first project...`);
            selected = projects[0].id;
        }
    }

</script>

<!-- TODO: for some reason it returns the text value instead of the option avlue -->
<!-- TODO: make "enhanced" property work :( -->
{#if !errorResult}
    {#if projects.length && selected}
<!--        <Select {variant} withLeadingIcon bind:value={selected} {label} style="{fullwidth ? 'width: 100%;' : ''} {style}">-->
<!--            <span slot="icon"><Icon class="material-icons">work</Icon></span>-->
<!--            {#each projects as project}-->
<!--                <Option-->
<!--                    value="{project.id}"-->
<!--                    selected={selected === project.id}>-->
<!--                    {project.title}-->
<!--                </Option>-->
<!--            {/each}-->
<!--        </Select>-->

        <select {variant} withLeadingIcon bind:value={selected} {label} style="{fullwidth ? 'width: 100%;' : ''} {style}">
<!--            <span slot="icon"><Icon class="material-icons">work</Icon></span>-->
            {#each projects as project}
                <option
                        value="{project.id}"
                        selected={selected === project.id}>
                    {project.title}
                </option>
            {/each}
        </select>
    {:else}
        ...
    {/if}
{:else}
    there was an error listing projects
{/if}

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>
        {#if help}
            {help}
        {:else}
            <slot name="help">

            </slot>
        {/if}
    </HelperText>
{/if}

{#await loadRequest}
    <LoadingModal global={false}/>
{:catch}
    there was an error loading projects
{/await}